/**
 * This file is part of the "Awaken Media" project.
 *
 * (c) 2017 - CanalPlus International
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withTranslation } from 'react-i18next';

import { fetchCoordinates } from 'shared/modules/geolocation/actions/index';
import isFetchingCoordinatesPending from 'shared/modules/geolocation/selectors/isFetchingCoordinatesPending';
import pushURLHandler from 'shared/helpers/router/pushURLHandler';
import ShopSearch from '../components/ShopSearch';
import { fetchShops, filterShops, resetFilters } from '../../shared/actions';
import { getFilterWithOptions } from '../../shared/selectors';

const getCityFilter = getFilterWithOptions('city');

const mapStateToProps = state => ({
  filterCity: getCityFilter(state),
  fetchingCoordinatesPending: isFetchingCoordinatesPending(state)
});

const mapDispatchToProps = {
  fetchCoordinates,
  fetchShops,
  filterShops,
  resetFilters,
  pushURLHandler
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withTranslation()
)(ShopSearch);
